import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '@sravni/react-design-system';
import modules_9ece3fb3 from './CardTitle.module.scss.js';

var Text = Typography.Text;
var CardTitle = function (props) {
    var title = props.title, subTitle = props.subTitle, icon = props.icon;
    return (jsxs("div", { className: modules_9ece3fb3.root, children: [jsx("div", { children: icon }), jsxs("div", { className: modules_9ece3fb3.info, children: [jsx(Text, { strong: true, size: 16, children: title }), jsx(Text, { uppercase: true, strong: true, size: 10, className: modules_9ece3fb3.subTitle, children: subTitle })] })] }));
};

export { CardTitle };
//# sourceMappingURL=CardTitle.js.map
